import { createContext, useContext, useEffect, useState } from 'react'
import { GameModel } from '../../domain/model/game.model'
import { MissionModel } from '../../domain/model/mission.model'
import { makeLoadBySlug, makeTeamByCode } from '../../main/usecases/game/load-games-factory'
import { getAssetUrl } from '../utils/assets_helpers'
import { useTour } from './tour'
import { usePage } from './page'
import { getTeam } from '../utils/team_helpers'
import { makeLoadPointsBySlug } from '../../main/usecases/points/points-factory'
import { addLocalStorage, clearGame, getLocalStorage, removeLocalStorage, clearLocalStorage } from '../utils/storage_helpers'
import { orderByPosition } from '../utils/mission_helpers'
import { isValidGameCode } from '../utils/is_valid_game_code'
import { addLanguage } from '../adapters/translate/translate'
import { getUser, isAuthenticatedUser } from '../utils/storage/user'
import { useNavigate } from 'react-router-dom'
import { makeCurrentUser } from '../../main/usecases/users/users-factory'
import { BgModal, CloseModal, ModalContent, ModalError } from './style'
import { getCurrentUser, signOut } from 'aws-amplify/auth'
import { clearStorage } from '../../presentation/utils/clear_storage'
import SelectGameModal from '../components/modais/select_game_modal'

const GameContext = createContext<any>(null)

export async function isAuthenticatedU () {
  try {
    await getCurrentUser()
    return true
  } catch {
    return false
  }
}

export const GameProvider = ({ children }: any) => {
  const [gameLoading, setGameLoading] = useState<boolean>(true)
  const [game, setGame] = useState<GameModel|any>(null)
  const [points, setPoints] = useState<number>(0)
  const [missionList, setMissionList] = useState<MissionModel[]|any>([])
  const [missionParentList, setMissionParentList] = useState<MissionModel[]|any>([])
  const [sortedMission, setSortedMission] = useState<MissionModel[]|any>([])
  const { toggleBackground, toggleLogo, toggleInstructionsContent, toggleBaseColor, toggleGameDocument } = usePage()
  const { toggleShowTour } = useTour()
  const team = getTeam()
  const navigate = useNavigate()
  const [teamRecovery, setTeamRecovery] = useState<boolean>(false)

  const [showChangeGameModal, setShowChangeGameModal] = useState<boolean>(false)

  const toggleGame = (value: GameModel) => {
    setGame(value)
  }

  const handleToggleChangeGameModal = () => {
    setShowChangeGameModal(prev => !prev)
  }

  async function teamRecoverySubmit (e:any) {
    e.preventDefault()
    try {
      const res = await makeTeamByCode(e.target.code.value).loadBySlug()
      addLocalStorage('team', JSON.stringify(res))
      window.location.href = '/'
    } catch (error) {
      console.error(error)
    }
  }

  function addStatusInGameMissions () {
    const localAnswers = JSON.parse(getLocalStorage('localAnswers') || '[]')
    setMissionParentList((state: MissionModel[]) => {
      return state.map((mission: MissionModel, idx: number) => {
        mission.status = idx === 0 ? 'current' : 'blocked'
        if (localAnswers.find((item:any) => item.uuid === mission.uuid)) mission.status = 'done-group'

        mission.childMissions = mission.childMissions.sort(orderByPosition).map((missionChild: MissionModel) => {
          missionChild.status = 'blocked'
          if (localAnswers.find((item:any) => item.uuid === missionChild.uuid))mission.status = 'done'
          return missionChild
        }, [])

        return mission
      })
    })
  }

  function updateStatusMission () {
    setMissionParentList((state: MissionModel[]) => {
      return state.map((mission: MissionModel) => {
        if (mission.status === 'current') {
          mission.status = 'done-group'
        }

        mission.childMissions = mission.childMissions.sort(orderByPosition).map((missionChild: MissionModel) => {
          if (missionChild.status === 'current') {
            missionChild.status = 'done'
          }
          return missionChild
        }, [])

        return mission
      })
    })
  }

  async function loadGame () {
    try {
      setGameLoading(true)
      let data:any = null

      const isLogged = await isAuthenticatedU()
      const userGame = getUser()?.team?.games[0]
      let loadData = true

      if (isLogged && userGame?.type === 'together') {
        const localPath = window.location.pathname
        if (localPath.replace(/\//g, '') !== getUser()?.team?.games[0].code && isValidGameCode()) {
          const getGameCodeData: GameModel = await makeLoadBySlug().load(localPath)
          if (!!getGameCodeData?.code && getGameCodeData?.code !== getLocalStorage('gameCode')) {
            try {
              await signOut()
              clearStorage()
              clearLocalStorage()
            } catch (e) {
              console.error(e)
            }

            clearGame()
            addLocalStorage('gameCode', getGameCodeData?.code)
            data = await makeLoadBySlug().load(`/${getGameCodeData?.code}`)
            loadData = false
          }
        } else {
          if (getLocalStorage('gameCode') !== getUser()?.team?.games[0].code) {
            clearGame()
          }
          data = getUser()?.team?.games[0]
          addLocalStorage('gameCode', getUser()?.team?.games[0].code)
          setGame(getUser()?.team?.games[0])
        }
      } else if (isValidGameCode()) {
        const getGameCodeData: GameModel = await makeLoadBySlug().load(window.location.pathname)
        if (!!getGameCodeData?.code && getGameCodeData?.code !== getLocalStorage('gameCode')) {
          clearGame()
          addLocalStorage('gameCode', getGameCodeData?.code)
        }
      }

      if (!isLogged && getLocalStorage('gameCode') && loadData) {
        data = await makeLoadBySlug().load(`/${getLocalStorage('gameCode')}?team=${team?.id}`)
      }

      if (data) {
        removeLocalStorage('support')
        removeLocalStorage('signUp')
        removeLocalStorage('gameLanguage')

        const gameRegisterType = data?.gameRegisterType || null
        const signUp = gameRegisterType === 'fullname_spreadsheet'

        addLocalStorage('support', JSON.stringify(data.support))
        addLocalStorage('signUp', JSON.stringify(signUp))
        addLanguage(getLanguage(data.language))
        addLocalStorage('languageChoosed', JSON.stringify(true))
        addLocalStorage('gameLanguage', getLanguage(data.language))

        if (data.type === 'together' && !isLogged) navigate('/login')
        setGame(data)
        addLocalStorage('gameTitle', data?.name)
        setSortedMission([...data?.missions].sort((a, b) => a.position - b.position))
        setMissionList(data?.missions.filter((item: MissionModel) => (item.type !== 'welcome' && item.type !== 'instructions')))
        setMissionParentList(data?.missions.filter((item: MissionModel, index:number) => (item.isParent === true && index > 1)))
        const instructionsMission = data?.missions.find((item:any) => item.type === 'instructions')
        if (toggleInstructionsContent)toggleInstructionsContent(instructionsMission?.imageFull || '', instructionsMission?.instructions || '')
        if (toggleBackground)toggleBackground(data.backgroundImage ? getAssetUrl('backgroundImage', data.backgroundImage) : null)
        if (toggleLogo)toggleLogo(getAssetUrl('logo', data.logo))
        if (toggleBaseColor)toggleBaseColor(data.baseColor)
        if (toggleShowTour)toggleShowTour(data.showInstructions)
        if (toggleGameDocument)toggleGameDocument(getAssetUrl('documentAttachment', data?.documentAttachment))

        addStatusInGameMissions()
        if (data.type === 'linear') {
          if (!isAvailable(data)) {
            removeLocalStorage('pageMessage')
            addLocalStorage('pageMessage', 'finished')
            clearGame()
            navigate('/game-not-found')
          }
        }
      }

      setGameLoading(true)
    } catch (error) {
      console.error('GameProvider.useEffect', error)
    } finally {
      setGameLoading(false)
    }
  }

  async function loadPoints () {
    try {
      const isLogged = await isAuthenticatedUser()
      if (isLogged) {
        const user = await makeCurrentUser().load()
        setPoints(user.points)
      } else if (game && getTeam()) {
        const points = await makeLoadPointsBySlug(getTeam()?.id, game.uuid).loadBySlug()
        setPoints(points)
      }
    } catch {
      throw new Error('Error loading points')
    }
  }

  const isTogether = () => {
    if (!game) {
      return null
    }
    return game?.type === 'together'
  }

  useEffect(() => {
    (async () => {
      await loadGame()
    })()
  }, [])

  useEffect(() => {
    if (missionParentList) {
      addStatusInGameMissions()
    }
  }, [game])

  const getLanguage = (language: string) => {
    switch (language) {
      case 'portuguese':
        return 'pt_BR'
      case 'english':
        return 'en'
      case 'spanish':
        return 'es'
      default:
        return 'pt_BR'
    }
  }

  const isAvailable = (game:GameModel|any) => {
    const now = new Date()
    const availableUntil = new Date(game.availableUntil)
    const nowWithoutTime = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    const availableUntilWithoutTime = new Date(availableUntil.getFullYear(), availableUntil.getMonth(), availableUntil.getDate())
    return nowWithoutTime <= availableUntilWithoutTime
  }

  return (
    <GameContext.Provider
        value={{
          gameLoading,
          game,
          loadGame,
          toggleGame,
          missionList,
          missionParentList,
          sortedMission,
          updateStatusMission,
          addStatusInGameMissions,
          loadPoints,
          points,
          setPoints,
          isTogether,
          setTeamRecovery,
          handleToggleChangeGameModal
        }}>
      {children}

      {teamRecovery &&
        <ModalError>
          <BgModal />
          <ModalContent style={{ padding: '60px 16px' }}>
            <CloseModal onClick={() => setTeamRecovery(false)}>+</CloseModal>
            <form onSubmit={teamRecoverySubmit}>
              <h2>Recuperar game</h2>
              <input type='text' name='code' placeholder='Entre como o código do time'/>
              <button type='submit'>Recuperar</button>
            </form>
          </ModalContent>
        </ModalError>
      }

      {!!showChangeGameModal &&
        <SelectGameModal onAction={() => setShowChangeGameModal(false)} />
      }

    </GameContext.Provider>
  )
}

export const useGame = () => {
  const context = useContext(GameContext)
  if (!context) throw new Error("It's necessary to use the GameProvider")

  return (
    { ...context }
  )
}
